<template>
  <div class="routes-list-new-item"
       tabindex="0"
       @click="startNewRoute"
  >
    <div class="routes-list-new-item__icon">
      <app-icon icon="route-marker-template-new"/>
    </div>

    <div class="routes-list-new-item__title">
      {{ $t("routesList.newItemLabel") }}
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "RoutesListNewItem",
  methods: {
    ...mapActions('Routes', ['startNewRoute'])
  }
}
</script>

<style lang="scss">
.routes-list-new-item {
  display: flex;
  align-items: center;
  grid-column-gap: 12px;
  padding: 15px 17px;
  transition: background-color .3s;
  background-color: rgba($app-primary-color, 0);
  cursor: pointer;
  height: fit-content;

  &:hover {
    background-color: rgba($app-primary-color, 0.15);
  }

  &__icon {
    width: 84px;
    height: 84px;
  }

  &__title {
    font-size: 20px;
    font-weight: 600;
    color: $app-primary-color
  }

}
</style>